import { GetProductSwitchesQuery, ProductSwitchFragmentFragment } from 'data/__generated__';

import { GET_PRODUCT_SWITCHES_QUERY } from 'data/queries/productSwitch';
import { apolloClient } from '../../../App';

export const productSwitchesUpdatedOrCreatedHandler = (
    productSwitchesUpdatedOrCreated: ProductSwitchFragmentFragment[],
) => {
    let currentProductSwitches = [] as GetProductSwitchesQuery['getProductSwitches'];

    const result = apolloClient.readQuery<GetProductSwitchesQuery>({ query: GET_PRODUCT_SWITCHES_QUERY });
    if (!result) {
        return;
    }
    currentProductSwitches = result.getProductSwitches;

    const updatedOrCreatedProductSwitchIds = productSwitchesUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedProductSwitches = currentProductSwitches.filter(
        ({ _id }) => !updatedOrCreatedProductSwitchIds.includes(_id),
    );
    const newProductSwitches = [...productSwitchesUpdatedOrCreated, ...nonUpdatedOrCreatedProductSwitches];

    apolloClient.writeQuery<GetProductSwitchesQuery>({
        query: GET_PRODUCT_SWITCHES_QUERY,
        data: { getProductSwitches: newProductSwitches },
    });
};

export const productSwitchArchivedHandler = (archivedProductSwitch: ProductSwitchFragmentFragment) => {
    let currentProductSwitches = [] as GetProductSwitchesQuery['getProductSwitches'];

    const result = apolloClient.readQuery<GetProductSwitchesQuery>({ query: GET_PRODUCT_SWITCHES_QUERY });
    if (!result) {
        return;
    }
    currentProductSwitches = result.getProductSwitches;

    const newProductSwitches = currentProductSwitches.filter(({ _id }) => _id !== archivedProductSwitch._id);

    apolloClient.writeQuery<GetProductSwitchesQuery>({
        query: GET_PRODUCT_SWITCHES_QUERY,
        data: { getProductSwitches: newProductSwitches },
    });
};
